
<script>

export default {
  name: 'UserField',
  props: ['item', 'hide_label'],  
  //template: '#field',
  data: function(){

    return {dataAutocomplete:{items:[]}}

  },
  mounted() {


  },
 
  created(){

    
      //console.log(this.item);

  },
  methods: {
    
      searchLegalPerson: function(value)
      {
       var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party";
        var token = "8a7684d0d46df1784e0c411541b15430d79c5932";
        var query = value;
        let vue = this;
        var options = {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({query: query})
        }

  
        fetch(url, options)
        .then(response => response.json())
        .then(result => {
          let items  = [];
          
            result.suggestions.forEach(element => {

                let city = element.data.address.data.city !== null?" г. "+element.data.address.data.city:"";
                items.push({value_text: element.value+city+", ИНН: "+element.data.inn, item: element});

                //console.log(vue.dataAutocomplete);


            });
            vue.$set(vue.dataAutocomplete, "items", items);

        })
        .catch(error => console.log("error", error));

        
        //this.$emit('search-inn', event.target.value);
      },

  	  rememberValue: function(prop, event)
			{

           localStorage.setItem(prop.CODE, event.target.value);
    
        this.$emit('input', event.target.value);
        //localStorage.getItem();
         if($.inArray(prop.CODE, ["INN", "COMPANY", "KPP"]) > -1)
        {
          this.searchLegalPerson(event.target.value);
        }
        
       

			},
      pickLegalPerson: function(item)
      {
          this.dataAutocomplete.items = [];
          this.$emit('search-inn', item.item);
      }
   },
  computed: {
    // геттер вычисляемого значения
    setValue: function () {
     
     
       let value_storage = localStorage.getItem(this.item.CODE);

        

          if(this.item.VALUE != "")
          {
                return this.item.VALUE;
          }

          if(value_storage)
          {
            
            this.$emit('input', value_storage);
            return value_storage;
          }
           
           return "";
    }
  },  
}

</script>



<template>

    
    <div>
      <label for="" class="prop" v-bind:class="{required:item.REQUIRED == 'Y'}" v-if="!hide_label">{{item.NAME}}</label>
      <input v-if="item.TYPE=='STRING' && item.MULTILINE !=='Y'" type="text" 
      v-bind:name="'ORDER_PROP_'+item.ID" 
      v-bind:placeholder="item.NAME" 
      v-on:input="rememberValue(item, $event)" 
      v-bind:required='item.REQUIRED == "Y"'
      v-bind:class="{error:item.ERRORS.length > 0} "
      v-bind:value="setValue"
      >
      <div class="error-list" v-if="item.ERRORS.length > 0">
          <div class="error-one" v-for="error in item.ERRORS">{{error}}</div>
      </div>
      <span v-if='hide_label && item.REQUIRED == "Y"' class="requared">
        *
      </span>   

      <textarea v-if="item.TYPE=='STRING' && item.MULTILINE=='Y'" type="text" 
                v-bind:name="'ORDER_PROP_'+item.ID" 
                v-bind:placeholder="item.NAME"  
                v-on:input="rememberValue(item, $event)" 
                v-bind:required='item.REQUIRED == "Y"'
                v-bind:class="{error:item.ERRORS.length > 0}"
                v-bind:value="setValue"
                >
      </textarea>

      <div class="autocomplete" v-if="dataAutocomplete.items.length > 0">
          <div @click="pickLegalPerson(item)" class="one-variant" v-for="item in dataAutocomplete.items" >
                {{item.value_text}}
          </div>
      </div>      

    </div>

</template>